<template>
  <ModalPlay size="xs" hide-header @close="emit('close')">
    <div class="tw:flex tw:flex-col tw:items-center tw:justify-center tw:gap-5 tw:text-center tw:py-4">
      <div class="tw:flex tw:items-center tw:justify-center tw:w-20 tw:h-20 tw:rounded-full tw:bg-(--maincolor)/10">
        <IconGoogle name="workspace_premium" fill size="2.5rem" color="var(--maincolor)" />
      </div>
      <TextPlay weight="bold" size="xl" color="var(--fontcolor)" :text="$t('modal_new_certificate.title')" />
      <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component vue/no-v-html -->
      <TextPlay size="sm" color="var(--text-color)" v-html="getPercentageText()" />
      <TextPlay size="sm" color="var(--text-color)">
        {{ $t('modal_new_certificate.link_page') }}
        <router-link to="/certificates" class="tw:text-(--maincolor) tw:font-semibold" @click.capture="emit('close')">
          {{ $t('modal_new_certificate.title_routes') }}
        </router-link>
      </TextPlay>
      <TextPlay size="sm" color="var(--text-color)" :text="$t('modal_new_certificate.congragulations')" />
      <ButtonPlayV2
        variant="filled"
        icon="file_download"
        :text="$t('modal_new_certificate.download')"
        @click="downloadCertificate"
      />
    </div>
  </ModalPlay>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { ModalPlay } from '@/components/atomic'
import { sanitize } from '@/utils/string-helpers'
import axios from 'axios'
import Cookies from 'js-cookie'

const props = defineProps<{
  courseTitle?: string
  certificateId?: string | number
}>()

const emit = defineEmits<{
  close: []
}>()

const { t } = useI18n()

function getPercentageText() {
  return t('modal_new_certificate.percent') + ' <b>' + props.courseTitle + '.</b>'
}

async function downloadCertificate() {
  const response = await axios({
    url: import.meta.env.VUE_APP_API_HOST + `/certificate/download/${props.certificateId}`,
    method: 'GET',
    responseType: 'blob',
    headers: {
      Authorization: Cookies.get('auth_greennCourse'),
    },
  })
  const type = response.headers['content-type']
  const fileURL = window.URL.createObjectURL(new Blob([response.data], { type }))

  const certificateNamePrefix = t('modal_new_certificate.certificate_name_prefix')
  const sanitizedCourseName = certificateNamePrefix + '-' + sanitize(props.courseTitle ?? '')

  const fileLink = document.createElement('a')
  fileLink.href = fileURL
  fileLink.setAttribute('download', sanitizedCourseName)
  document.body.appendChild(fileLink)
  fileLink.click()
}
</script>

<style lang="scss" scoped>
</style>
